
export const types ={
    saveValuesForm : "SAVE_VALUES_FORM"
}


export const saveValuesForm =  (form) =>{
    return{
        type:types.saveValuesForm,
        form
    }
}

